<template>
<!-- 添加‘暂不登录，跳转官网按钮’ -->
  <div class="wrap clearfix">
    <div id="loginForm">
      <div class="box">
        <p>四川省室内装饰协会-考试系统</p>
        <div class="item name" :class="inputClass">
          <span class="icon_box">
            <span class="iconfont icon-xingming_icon"></span>
          </span>
          <input type="text" placeholder="请输入姓名" v-model="info.name" @blur="blur()" @focus="focus()" >
        </div>
        <div class="item person_id" :class="inputClass">
          <span class="icon_box">
            <span class="iconfont icon-credentials_icon"></span>
          </span>
          <input type="text" placeholder="请输入身份证号" v-model="info.id" @blur="blur()" @focus="focus()" >
        </div>
        <div class="item password" :class="inputClass">
          <span class="icon_box">
            <span class="iconfont icon-mima4"></span>
          </span>
          <input placeholder="请输入密码" type="password" v-model="info.pass" @blur="blur()" @focus="focus()" >
        </div>
        <input type="button" @click="toLogin()" value="登录">
        <input class="official" type="button" @click="officialWeb()" value="暂不登录">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
      name:'login',
      data() {
        return {
          info:{
            name:'',
            id:'',  //123456123456123000
            pass:''
          },
          pendingExam:[],
          inputClass:'blur',
        };
      },
      mounted: function() {
        // console.log(this.$router);
        document.onkeydown = (e)=>{ // 回车提交表单
            // 兼容FF和IE和Opera
            var theEvent = window.event || e;
            var code = theEvent.keyCode || theEvent.which || theEvent.charCode;
            if (code == 13) {
                this.toLogin();
            }
        }
      },
      methods: {
        blur(){
          this.inputClass='blur'
        },
        focus(){
          this.inputClass='focus'
        },

        toLogin(){
          sessionStorage.setItem('user_name',this.info.name);
           sessionStorage.setItem('person_id',this.info.id);

          this.$http.post(this.baseURL+`/api/user/login?user_nickname=${this.info.name}&people_ID=${this.info.id}&user_pass=${this.info.pass}`,{})
          .then((res)=>{
              console.log(res);
              if(res.data.code===1){
                sessionStorage.setItem('token',res.data.data.token);
                console.log('ok',sessionStorage);

                return this.$http.post('http://exam.ah1d.com/api/exam/index',{  // 未考科目接口
                  token:res.data.data.token
                })

              }else{
                alert(res.data.msg)
              }

          })
          .then((res)=>{
            // console.log(res);
            this.pendingExam=res.data.data
            // console.log(this.pendingExam)
            var now=Date.parse(new Date())
            var examOn=this.pendingExam.some((item,i)=>{
              if(now>item.exam_start_time*1000 && now<item.exam_end_time*1000){
                console.log(Date.parse(item.exam_start_time*1000));
                console.log(Date.parse(item.exam_end_time*1000));
                sessionStorage.setItem('exam_name',item.exam_name)
                sessionStorage.setItem('exam_uuid',item.exam_uuid)
                 sessionStorage.setItem('timeDiff',item.exam_time_len/60)
                return true
              }else{
                return false
              }
            })
            console.log(examOn);
            if(examOn){
              console.log('正在考试');
              this.$router.push('/notice')
            }else{
              console.log('提前进入等候考试');
              this.$router.push('/home')
            }
          })
          .catch(err=>{
            console.log(err);
          })
        
        },

        officialWeb(){
          // window.location.href="http://www.cidasc.org/"
          var tempwindow=window.open('_blank');
          tempwindow.location="http://www.cidasc.org/"
        }
        
      }
  }
</script>

<style scoped>
.clearfix:before,
.clearfix:after{
  content: '';
  display: table;
}
.clearfix:after{
  clear: both;
}
.wrap{
  /* width: 1920px;
  height: 1080px; */
  width: 100%;
  height: 100%;
  background-image: url('/image/login.jpg');
  /* background-size: cover; */
   background-size: 100% 100%;
}
  #loginForm{
    width:33.3%;
    min-width:320px;
    height: 68.5%;
    margin-top: 8.2%;
    margin-left: 15%;
    background-image: url('/image/form_login.jpg');
    background-size: cover;
    /* border: 1px solid red; */
    border-radius: 4%;
    padding-top: 1px;
    box-shadow: 0 0 3px 1px #999;
    
  }
  #loginForm .box{
    width: 80%;
    margin-left: 10%;
    margin-top: 6%;
    /* border: 1px solid red; */
  }
  #loginForm .box p{
    font-size: 2rem;
    text-align: center;
  }
  #loginForm .box div.item{
    width: 83%;
    margin: 0 auto;
    padding: 0;
    height: 5rem;
    margin-top: 1.2rem;
    line-height: 5rem;
  }
  #loginForm .box>input{
    text-align: center;
    background: #4f93fe;
    width: 83%;
    height: 4rem;
    border-radius:2rem ;
    margin-left: 9%;
    margin-top: 3rem;
    font-size: 1.4rem;
    color: #fff;
  }
  #loginForm .box>input.official{
    background: #888;
  }
::-webkit-input-placeholder { /* WebKit browsers */
  color: #a9a9a9;
  font-size: 1.5rem;
}

::-moz-placeholder { /* Mozilla Firefox 19+ */
  color: #a9a9a9;
  font-size: 1.5rem;
}

:-ms-input-placeholder { /* Internet Explorer 10+ */
  color: #a9a9a9;
  font-size: 1.5rem;
} 
  #loginForm .box div.item span.icon_box{
    display: inline-block;
    width: 12%;
    /* background: tomato; */
    color: #4f93fe;  
  }
  #loginForm .box div.item input{
    width: 80% !important;
    width:19rem;
    height:2.6rem;
    padding:1.5rem;
    font-size:1.5rem;
    /* color: #bfbfbf; */
    color: #444;
  }
  .iconfont{
    font-size: 2.2rem;
    margin-right: 1.0rem;
  }
  input{
    transition:border .9s;
  }
 .blur{
   border-bottom: 1px solid #eee;
 }
 .focus{
    border-bottom:2px solid #4f93fe;
 }

 @media screen and (max-width: 720px) {
    #loginForm{
      margin-left: 0;
      width: 100%;
      height: 106%;
      margin-top: 0;
      border-radius:0 ;
      background-position: 10% 0;
    }
    #loginForm .box{
      margin-left: 0;
      width: 100%;
      margin-top: 30%;
    }
    #loginForm .box p{
      font-size: 7.3rem;
    }
    #loginForm .box div.item{
      height: 15rem;
              /* --这什么设置line-height为15rem会导致input下沉？ --- */
      /* line-height: 15rem; */
      /* border: 1px solid red; */
      padding-top: 1px solid transparent;
      margin-top: 11rem;
      overflow: hidden;
    }
    #loginForm .box div.item input{
      height: 15rem;
      height: 100%;
      /* border: 1px solid blue; */
      font-size: 7rem;
      color: #555;
    }
    #loginForm .box div.item input::-webkit-input-placeholder { 
      /* WebKit browsers */ 
      color: #ccc; 
      font-size: 5rem;
    } 

     #loginForm .box div.item span.icon_box{
       width: 15%;
      
     }
    #loginForm .box div.item span.icon_box span{
       font-size: 9rem;
    }

    #loginForm .box>input{
      margin-top: 10rem;
      height: 14rem;
      font-size: 6rem;
    }
 }
 

</style>